<template> 

  <div class="container pt-4">
 
    <div>
      
      <b-row align-v="center">

        <b-col lg="12">
 
          <div class="mt-4">

            <div class="mt-3">

              <label>Wpisz polecenie dla asystenta video:</label>

              <b-input-group>

                <b-form-textarea v-model="query" size="lg" rows="5" ref="query" placeholder="np. Wymyśl mi scenariusz do rolki"></b-form-textarea>
                
              </b-input-group>

            </div>

            <div class="mt-3">

              <label>Dodaj zdjęcie/grafikę (opcjonalnie):</label>

              <b-input-group>

                <b-form-file size="lg" v-model="file" ref="file" accept="image/jpeg, image/png, image/gif" placeholder="Kliknij i dodaj plik" browse-text="Wybierz"></b-form-file>

              </b-input-group>

            </div>
  
          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generate()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje tekst dla Ciebie <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowany tekst</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div v-html="result" class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;"></div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
  
  
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>


      <div class="mt-3">

        Przykładowe polecenia do Video Assistant AI: <Br/>
        <code>Przygotuj dla mnie raport podsumowujący wyniki sprzedaży za ostatni miesiąc [WPISZ DANE FIRMY].</code><br/>
        <code>Wygeneruj listę pomysłów na posty na Instagram w branży [WPISZ BRANŻĘ].</code><br/>
        <code>Zorganizuj spotkanie z zespołem na Zoomie i wyślij zaproszenia na [WPISZ DATĘ I GODZINĘ].</code><br/>
        <code>Napisz krótką notkę prasową o wprowadzeniu nowego produktu [WPISZ NAZWĘ PRODUKTU].</code><br/>
        <code>Zrób research na temat [WPISZ TEMAT] i podsumuj w 5 punktach.</code><br/>
        <code>Przygotuj prezentację w PowerPoint na temat [WPISZ TEMAT].</code><br/>
        <code>Stwórz 10 pytań do wywiadu z kandydatem na stanowisko [WPISZ STANOWISKO].</code><br/>
        <code>Napisz tekst zaproszenia na wydarzenie firmowe związane z [OPISZ WYDARZENIE].</code><br/>
        <code>Znajdź i zarezerwuj hotel na wyjazd służbowy w [WPISZ MIEJSCE I DATY].</code><br/>
        <code>Stwórz listę kontrolną dla nowego projektu o nazwie [WPISZ NAZWĘ].</code><br/>
        <code>Zaprojektuj plan kampanii reklamowej dla produktu [WPISZ PRODUKT].</code><br/>
        <code>Przygotuj grafik postów na social media promujący [WPISZ CO].</code><br/>
        <code>Napisz tekst oferty dla klienta zainteresowanego [OPISZ OFERTĘ].</code><br/>
        <code>Znajdź 5 najlepszych dostawców [WPISZ PRODUKT] w [WPISZ LOKALIZACJĘ].</code><br/>
        <code>Stwórz 10 pomysłów na tytuły bloga na temat [WPISZ TEMAT].</code><br/>
        <code>Zrób listę konferencji branżowych w [WPISZ BRANŻĘ] na najbliższe 6 miesięcy.</code><br/>
        <code>Opracuj strategię wdrożenia nowego pracownika na stanowisko [WPISZ STANOWISKO].</code><br/>
        <code>Zaplanuj budżet na kampanię reklamową dla [WPISZ CEL].</code><br/>
        <code>Przetłumacz dokument z [WPISZ JĘZYK ŹRÓDŁOWY] na [WPISZ JĘZYK DOCELOWY].</code><br/>
        <code>Przygotuj instrukcję obsługi dla nowego narzędzia [OPISZ NARZĘDZIE].</code><br/>

      </div>



    </div>

  </div>

</template>

<script>

  export default {
    name: 'AppAiSellingMachine',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        selectedText: '',
        query: "",
        finishContent: '',
        file: null,
        uploadedFileUrl: null,
        selectedSchema: null
      }
    },
    methods: {

      generate: function() {

        this.uploadedFileUrl = "";

        if(!this.query) return false;

        if (this.file) {

          this.$refs.generatePost.disabled = true

          const formData = new FormData();

          formData.append('file', this.$refs['file'].files[0]);

          const headers = {'Content-Type': 'multipart/form-data'};

          this.axios.post("https://soft.funnelstar.io/api/images/upload/", formData, {
            withCredentials: true,
            headers
          }).then((response) => {

            let data = response.data

            this.uploadedFileUrl = data.file

            if (this.uploadedFileUrl) {

              this.generateFromAi()

            }

          }).catch(function () {

            this.$refs.generatePost.disabled = false

          });


        } else {

          this.generateFromAi()

        }

      },

      generateFromAi: function() {

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""

        var query = "";
 
         
        query = this.query;

        query = query + "Używaj znaczników HTML zamiast markdown. Dozwolone znaczniki: Pogrubienie czyli <B></B>, i nowa linia <br/> . Zamiast znaczników nagłówków Hx użyj po prostu pogrubienia.";
        var doneText = "";

        var postData = {};

        if(this.uploadedFileUrl) {

          postData = { 'text': query, 'v': 'o1', 'graphic': this.uploadedFileUrl };

        } else {

          postData = { 'text': query, 'v': 'o1' };

        }


        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", postData, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
 
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');

          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowany tekst"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },
 
      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Post został skopiowany do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {

      this.$watch('finishContent', (value) => {

        var lines = value.split(/\r|\r\n|\n/);

        this.finishLinesCount = lines.length;

      })
 
    }

  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
</style>